/* eslint-disable */
import { manageMenusActionType } from "./actionTypes";

export const getMenus = (payload) => {
  return {
    type: manageMenusActionType.GET_MENUS,
    payload,
  };
};
export const getMenusSucceeded = (payload) => {
  return {
    type: manageMenusActionType.GET_MENUS_SUCCEEDED,
    payload,
  };
};

export const getMenusFailed = (payload) => {
  return {
    type: manageMenusActionType.GET_MENUS_FAILED,
    payload,
  };
};
